import { Link } from 'react-router-dom';

const featuredArticles = [
  {
    slug: 'hipobuy-spreadsheet',
    size: 'large',
    badge: 'Pillar Guide',
    badgeClass: 'bg-accent-100 text-accent-700',
    title: 'What Is Hipobuy Spreadsheet?',
    desc: 'Learn the fundamentals of the Hipobuy Spreadsheet system and how it helps shoppers discover products efficiently.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20spreadsheet%20notes%20next%20to%20laptop%20on%20wooden%20desk%2C%20small%20desk%20plant%20and%20warm%20desk%20lamp%20glow%2C%20cozy%20evening%20study%20session%20atmosphere%2C%20knowledge%20and%20organization%20theme%2C%20soft%20warm%20lighting%2C%20intimate%20productive%20workspace&width=960&height=720&seq=guide-pillar-v2&orientation=landscape',
  },
  {
    slug: 'hipobuy-spreadsheet-comparison',
    size: 'small',
    badge: 'Ultimate Comparison',
    badgeClass: 'bg-secondary-100 text-secondary-700',
    title: 'All Spreadsheet Tools Compared',
    desc: 'Hipobuy vs Kakobuy vs CSSBuy vs Superbuy vs Oopbuy — the most comprehensive comparison available anywhere.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20tablets%20side%20by%20side%20on%20clean%20desk%20showing%20different%20spreadsheet%20layouts%20and%20data%20dashboards%2C%20split%20screen%20comparison%20concept%2C%20coffee%20cup%20between%20devices%2C%20modern%20professional%20workspace%2C%20decision%20making%20and%20evaluation%20theme%2C%20soft%20natural%20daylight&width=640&height=480&seq=guide-compare-v2&orientation=landscape',
  },
  {
    slug: 'hipobuy-spreadsheet-safety',
    size: 'small',
    badge: 'Safety Guide',
    badgeClass: 'bg-accent-100/70 text-accent-800',
    title: 'Safe Shopping With Spreadsheets',
    desc: 'Essential safety tips, red flags to watch for, and best practices for shopping securely across all product categories.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Padlock%20placed%20on%20laptop%20keyboard%20with%20soft%20backlight%20glow%2C%20cybersecurity%20and%20online%20safety%20concept%2C%20warm%20ambient%20lighting%2C%20trust%20and%20digital%20protection%20theme%2C%20modern%20tech%20security%20aesthetic%2C%20clean%20minimalist%20composition&width=640&height=480&seq=guide-safety-v2&orientation=landscape',
  },
];

export default function FeatureGrid() {
  return (
    <section id="guides" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100/80 rounded-full text-accent-700 text-xs font-medium tracking-wider mb-4">
            SEO Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Master the{' '}
            <span className="text-accent-600">Hipobuy Spreadsheet</span>
            {' '}Ecosystem
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            In-depth guides to help you understand, compare and maximize your spreadsheet shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          <Link
            to={`/${featuredArticles[0].slug}/`}
            className="lg:col-span-3 lg:row-span-2 relative group cursor-pointer rounded-2xl overflow-hidden bg-background-100"
          >
            <div className="w-full h-full min-h-[360px]">
              <img
                src={featuredArticles[0].imageUrl}
                alt={featuredArticles[0].title}
                title={featuredArticles[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${featuredArticles[0].badgeClass}`}>
                {featuredArticles[0].badge}
              </span>
              <h3 className="mt-3 text-white text-lg md:text-xl font-heading font-semibold">{featuredArticles[0].title}</h3>
              <p className="mt-1.5 text-white/70 text-sm">{featuredArticles[0].desc}</p>
            </div>
          </Link>

          {featuredArticles.slice(1).map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}/`}
              className="lg:col-span-2 relative group cursor-pointer rounded-2xl overflow-hidden bg-background-100"
            >
              <div className="w-full h-full min-h-[240px]">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${article.badgeClass}`}>
                  {article.badge}
                </span>
                <h3 className="mt-2 text-white text-base md:text-lg font-heading font-semibold">{article.title}</h3>
                <p className="mt-1 text-white/70 text-xs md:text-sm">{article.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}